import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	autocompleteBox: {
		width: 250,
	},
	clearButtons: {
		alignItems: 'center',
		display: 'flex',
	},
	clearFilter: {
		':hover': {
			color: brandPrimaryHover,
			textDecoration: 'underline',
		},
		color: brandPrimary,
		cursor: 'pointer',
		fontSize: 14,
		marginLeft: 20,
	},
	container: {
		display: `flex`,
		flexDirection: `column`,
		height: '100%',
	},
	dateInput: {
		cursor: 'pointer',
		marginLeft: 10,
	},
	dateInputContainer: {},
	dayPicker: {
		height: 50,
		overflow: 'hidden',
	},
	dropdown: {
		width: 220,
	},
	exportButton: {
		alignSelf: 'center',
		color: brandPrimaryHover,
		cursor: 'pointer',
		fontSize: 14,
		whiteSpace: 'nowrap',
	},
	iconSpan: {
		margin: '4px 8px 0px 4px',
	},
	largeText: {
		color: titles,
		fontSize: 14,
	},
	monthlyBillingInput: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 15,
	},
	quickSightLink: {
		color: brandPrimaryHover,
		display: 'flex',
		fontSize: 14,
		paddingLeft: 4,
		paddingTop: 14,
	},
	quickSightText: {
		paddingLeft: 8,
	},
	search: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '1em',
	},
	searchBox: {
		alignItems: 'center',
		backgroundColor: '#f9f9f9',
		border: '1px solid #CCC',
		borderRadius: 3,
		color: '#4a4a4a',
		display: 'flex',
		fontSize: 14,
		height: 40,
		outline: 'none',
		padding: 6,
		width: 260,
	},
	searchSection: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		margin: '30px 0 0',
	},
	title: {
		color: titles,
		fontSize: 24,
		marginRight: 30,
	},
	titleSection: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: '20px 0 10px',
	},
	trigger: {
		background: '#f9f9f9',
		...CssSelectors.allChildren({
			color: titles,
		}),
	},
	triggerContainer: {
		background: '#f9f9f9',
		borderColor: 'rgb(204,204,204)',
		minWidth: 220,
		maxWidth: 250,
	},
	checkboxContainer: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 10,
		padding: '0 10px',
		minHeight: 37,
	},
});
